import { Badge } from '@/components/ui/badge';
import type { OverallStatus } from '@/types/fund-transactions';

const LABELS: Record<OverallStatus, string> = {
  DRAFT_PC: 'Draft - PC',
  AWAITING_BANK_ENTRIES: 'Awaiting bank entries',
  AWAITING_FUND_APPROVAL: 'Awaiting fund approval',
  COMPLETE: 'Complete',
};

type BadgeVariant = 'secondary' | 'outline' | 'success';

const VARIANTS: Record<OverallStatus, BadgeVariant> = {
  DRAFT_PC: 'secondary',
  AWAITING_BANK_ENTRIES: 'outline',
  AWAITING_FUND_APPROVAL: 'outline',
  COMPLETE: 'success',
};

interface Props {
  status: OverallStatus | null;
}

export function OverallStatusBadge({ status }: Props) {
  if (status === null) return null;
  return <Badge variant={VARIANTS[status]}>{LABELS[status]}</Badge>;
}
